// extracted by mini-css-extract-plugin
export default {"container":"YO-z","title":"ZO-z","link":"_O-z"};